module.exports = __webpack_public_path__ + "static/media/Combined_Shape__1_.a2092475.svg";